import styled from 'styled-components'

export const TextComponent = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  color: ${props => props.theme.additionalTextColor};
`